/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Invoice,
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
} from './Invoice';

/**
 * 
 * @export
 * @interface GetInvoiceResponse
 */
export interface GetInvoiceResponse {
    /**
     * status code
     * @type {number}
     * @memberof GetInvoiceResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetInvoiceResponse
     */
    message: string;
    /**
     * 
     * @type {Invoice}
     * @memberof GetInvoiceResponse
     */
    data: Invoice;
}

export function GetInvoiceResponseFromJSON(json: any): GetInvoiceResponse {
    return GetInvoiceResponseFromJSONTyped(json, false);
}

export function GetInvoiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoiceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': InvoiceFromJSON(json['data']),
    };
}

export function GetInvoiceResponseToJSON(value?: GetInvoiceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': InvoiceToJSON(value.data),
    };
}

